import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import request2FAResetToken from '../../actions/request-2fa-reset-token';
import ModalDialog from '../ModalDialog';
import TextField from '../fields/TextField';
import './_styles_/Request2FAResetPopup.css';
import useMultiValidator from '../../hooks/useMultiValidator';
import { universalUserIdValidator, userEmailValidator } from '../../validators/users';
import PasswordField from '../fields/PasswordField';

Request2FAResetPopup.propTypes = {
    hideDialog: PropTypes.func.isRequired,
};

function Request2FAResetPopup(props) {
    const {
        hideDialog,
    } = props;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [userId, setUserId] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [userPassword, setUserPassword] = useState('');
    const onSubmit = (event) => {
        dispatch(request2FAResetToken(userId, userEmail, userPassword));
        event.preventDefault();
        hideDialog();
    };
    const onCancel = () => hideDialog();
    const { validators, isValid } = useMultiValidator(false, {
        userId: universalUserIdValidator(t),
        userEmail: userEmailValidator(t),
    });
    const [isDisabled, setIsDisabled] = useState(true);
    isValid()
        .then(() => setIsDisabled(false))
        .catch(() => setIsDisabled(true));

    return (
        <ModalDialog onCancel={hideDialog}>
            <div className="request-2fa-reset-popup-dialog">
                <h4>{t('request-2fa-reset.title')}</h4>
                <form className="request-2fa-reset" onSubmit={onSubmit}>
                    <div className="request-2fa-reset-input-row">
                        <TextField
                            label={t('request-2fa-reset.user-id')}
                            inputId="request-2fa-reset-user-id"
                            className="request-2fa-reset--field--user-id"
                            value={userId}
                            validator={validators.userId}
                            onChange={setUserId}
                            autoComplete="off"
                            placeholder="M7AUSRXX"
                            useDynamicWidth={false}
                        />
                    </div>
                    <div className="request-2fa-reset-input-row">
                        <TextField
                            label={t('request-2fa-reset.email')}
                            inputId="request-2fa-reset-email"
                            className="request-2fa-reset--field--email"
                            value={userEmail}
                            validator={validators.userEmail}
                            onChange={setUserEmail}
                            autoComplete="off"
                            placeholder="your.email@example.com"
                            useDynamicWidth={false}
                        />
                    </div>
                    <div className="request-2fa-reset-input-row">
                        <PasswordField
                            label={t('login.password')}
                            inputId="request-2fa-reset-password"
                            className="request-2fa-reset--field--password"
                            value={userPassword}
                            onChange={setUserPassword}
                            useDynamicWidth={false}
                        />
                    </div>
                    <div className="buttons">
                        <button disabled={isDisabled} className="button button-bordered request-2fa-reset-button" type="submit" aria-label={t('request-2fa-reset.submit')}><FontAwesomeIcon
                            icon="life-ring"
                        />&nbsp;{t('request-2fa-reset.submit')}
                        </button>
                        <button className="button button-bordered back-button" type="button" onClick={onCancel}>{t('button.cancel')}</button>
                    </div>
                </form>
            </div>
        </ModalDialog>
    );
}

export default Request2FAResetPopup;
